<template>
  <!-- 页面跳转，如果是外链则渲染a标签，是路由则渲染router-link -->
  <component :is="componentName(to)" v-bind="linkProps(to)" class="app-link">
    <slot/>
  </component>
</template>

<script>
import { isExternal } from '@/utils'

export default {
  name: 'AppLink',
  props: {
    to: {
      type: [String, Object],
      required: true
    }
  },
  methods: {
    // 是不是外链
    isExternalLink(routePath) {
      return isExternal(routePath)
    },

    // 动态组件
    componentName(to) {
      return this.isExternalLink(to) ? 'a' : 'router-link'
    },

    // 组件属性
    linkProps(url) {
      if (this.isExternalLink(url)) {
        return {
          href: url,
          target: '_blank',
          rel: 'noopener'
        }
      }
      return {
        to: url
      }
    }
  }
}
</script>